import {Component, OnDestroy, OnInit, Renderer2} from "@angular/core";
import {VideoService} from "./video.service";
import {AndroidPermissions} from "@ionic-native/android-permissions";
import {Insomnia} from "@ionic-native/insomnia";
import {Events, Platform} from "ionic-angular";

declare var OT: any;
declare var document: any;

@Component({
  selector: 'app-video-meeting',
  template: `
    <div id="meeting-container" *ngIf="meetingOngoing">
      <div id="publisher"></div>
      <div id="subscriber-1"></div>
      <div id="subscriber-2"></div>
      <div id="subscriber-3"></div>
      <div class="controls">
        <button ion-button round icon-only large color="danger" (click)="endCall()">
          <ion-icon name="call"></ion-icon>
        </button>
        <button ion-button round icon-only large color="light" (click)="toggleVideo()">
          <ion-icon name="{{ camOn ? 'videocam' : 'eye-off'}}"></ion-icon>
        </button>
        <button ion-button round icon-only large color="light" (click)="toggleAudio()">
          <ion-icon name="{{ micOn ? 'mic' : 'mic-off'}}"></ion-icon>
        </button>
        <!--<button ion-button round icon-only large><ion-icon name="chatboxes"></ion-icon></button>-->
      </div>
    </div>
  `,
  providers: [AndroidPermissions, Insomnia]
})
export class VideoMeetingComponent implements OnInit, OnDestroy {
  meetingStateSub;
  meetingOngoing = false;
  session: any;
  publisher: any;
  subscribers = [];
  micOn = true;
  camOn = true;
  restoreBackButtonAction = null;
  private streamsSub;

  constructor(private videoService: VideoService,
              private permissions: AndroidPermissions,
              private events: Events,
              private insomnia: Insomnia,
              private renderer: Renderer2,
              private platform: Platform
  ) {
  }

  ngOnInit(): void {
    this.meetingStateSub = this.videoService.getMeetingState()
      .subscribe((state) => {
        this.checkPermissions()
          .then((res) => this.startCall(state));
      });
  }

  ngOnDestroy(): void {
    this.meetingStateSub.unsubscribe();
  }

  checkPermissions() {
    return this.permissions.requestPermissions([
      this.permissions.PERMISSION.CAMERA, this.permissions.PERMISSION.RECORD_AUDIO, this.permissions.PERMISSION.INTERNET
    ])
  }

  startCall(state: { sessionId: string; token: string; apiKey: string }) {
    // Exchange precall session/token for meeting session/token
    this.videoService.exchangeToken(state.token, state.sessionId).subscribe((res) => {
      this.meetingOngoing = true;

      this.initSession({
        sessionId: res.session_id,
        token: res.token,
        apiKey: state.apiKey
      });
    });

    this.insomnia.keepAwake();
    this.makeUITransparent();
    this.disableBackButton();
  }

  private disableBackButton(){
    this.restoreBackButtonAction = this.platform.registerBackButtonAction(() => null, 10);
  }

  private restoreBackButton(){
    this.restoreBackButtonAction && this.restoreBackButtonAction();
  }

  private makeUITransparent(){
    this.renderer.addClass(document.body, 'meeting-ongoing');
  }

  private restoreUIBackground(){
    this.renderer.removeClass(document.body, 'meeting-ongoing');
  }

  private updateVideosLayout() {
    let meetingContainer = document.getElementById('meeting-container');
    meetingContainer.className = 'videos-' + (this.subscribers.length + 1);
    setTimeout(() => OT.updateViews());
  }

  private initPublisher() {
    this.publisher = OT.initPublisher('publisher');
    this.updateVideosLayout();
  }

  private initSession(state) {
    this.session = OT.initSession(state.apiKey, state.sessionId);

    // We use videoService to cache events. as we need to catch them early on, but use them later
    this.session.on('streamCreated', (event) => this.videoService.addStream(event));
    this.session.on('streamDestroyed', (event) => this.onStreamDestroyed(event));

    this.session.connect(state.token, (event) => this.onSessionConnected(event));
  }

  private onSessionConnected(event) {
    this.initPublisher();
    this.session.publish(this.publisher);

    this.publisher.on('streamCreated', () => {
      this.streamsSub = this.videoService.getStreams()
        .subscribe(event => this.onStreamCreated(event));
    });
  }

  private onStreamCreated(event) {
    let subContainerId = 'subscriber-' + (this.subscribers.length + 1);

    let sub = this.session.subscribe(event.stream, subContainerId);

    this.subscribers.push(sub);

    this.updateVideosLayout();
  }

  private onStreamDestroyed(event) {
    try {
      let subscriber = this.subscribers.find((sub) => sub.streamId = event.stream.streamId);
      if (subscriber) {
        this.subscribers.splice(this.subscribers.indexOf(subscriber), 1);
        this.session.unsubscribe(subscriber);
        this.updateVideosLayout();
      }
    }
    catch (err) {
      console.error("Call session unsubscribe failed: " + err.message);
    }
  }

  private unsubscribeFromStreams() {
    this.subscribers.forEach(sub => {
      try {
        this.session.unsubscribe(sub);
      }
      catch (err) {
        console.error("Call session unsubscribe failed: " + err.message);
      }
    });
    this.subscribers = [];

    this.streamsSub && this.streamsSub.unsubscribe();
    this.videoService.clearStreams();
  }

  private unpublish() {
    try {
      this.session.unpublish();
    }
    catch (err) {
      console.error("Call session unpublish failed: " + err.message);
    }
    this.publisher = null;
  }

  endCall() {
    this.unsubscribeFromStreams();
    this.unpublish();

    this.session.disconnect();
    this.session = null;

    this.meetingOngoing = false;

    this.insomnia.allowSleepAgain();
    this.restoreUIBackground();
    this.restoreBackButton();
    this.events.publish('job:finished');
  }

  toggleAudio() {
    this.publisher.publishAudio(this.micOn = !this.micOn);
  }

  toggleVideo() {
    this.publisher.publishVideo(this.camOn = !this.camOn);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/video/video-meeting.component.ts